module.exports = __webpack_public_path__ + "img/icon-archive.1eb6eaf5.svg";